<template>
    <div class="group">
        <span title="More Information and Video" id="infoButton" v-on:click="aboutPage = true" class="about esri-icon-description">
            <span id="infoText">&nbsp;About this Map</span>
        </span>
      <transition name="fade">
          <div v-if="aboutPage" v-on:click.self="aboutPage = false" class="aboutPage">
              <div class="aboutPage-content">
                  <span v-on:click="aboutPage = false" style="float: right" class="esri-icon-close-circled"
                        title="Close Text Box"></span>
                  <h1> FY 26-29 Transportation Improvement Program (TIP) Projects</h1>

                  <p>Two documents are the foundation of SEMCOG’s transportation planning process: the Regional
                      Transportation Plan (RTP) and the Transportation Improvement Program (TIP).</p>

                  <ul>
                    <li>The Regional Transportation Plan (RTP) is the transportation planning policy document for the
                      seven-county SEMCOG region. It covers at least a 20-year timeframe (the
                      <a href="https://www.semcog.org/rtp">2050 RTP</a> is currently in effect) and contains a number
                      of policies guiding the use of federal-aid transportation funds in the region. The RTP is updated
                      every four years and approved by the General Assembly, SEMCOG’s policymaking body.</li>

                    <li>The Transportation Improvement Program (TIP) is a four-year list of federally funded transportation
                      projects in the seven-county SEMCOG region that implement the policies of the RTP. TIPs are required
                      by federal regulation to be updated every three years and approved by SEMCOG’s Executive Committee.
                      Visit the
                      <a href="https://www.semcog.org/transportation-improvement-program-tip">TIP webpage</a> for more
                      information. </li>
                  </ul>
                <h5>FY 2026 through FY 2029 Transportation Improvement Program (TIP)</h5>
                <p>
                  The FY 2026-2029 TIP includes a variety of projects designed to address regional transportation policies
                  and priorities – pavement, safety, bridge, operations, transit (capital and operations), capacity, and
                  pedestrian and bike mobility projects. The TIP can be amended five times annually. Visit the
                  <a href="https://www.semcog.org/transportation-improvement-program-tip" target="_blank">TIP webpage</a>
                  for the annual Amendment Schedule.


                </p>

                  <h5>Current TIP Amendment</h5>
                  <p>FY 26-29 TIP Amendment 26:5 (Full) is the fifth amendment of 2026. It is expected
                    to receive final approval the week of December 21, 2026.
                    Visit the <a href="https://www.semcog.org/transportation-improvement-program-tip" target="blank">TIP webpage</a>
                    for more information on this amendment.
                  </p>

                  <h3>Instructions</h3>
                  <ul>
                      <li>Click a project on the map to see more details. </li>
                      <li>The menus to the right side can be used to filter which projects appear on the map.
                      <ul>
                          <li>Project Type (Pavement, Ped/Bike, Safety, …)</li>
                          <li>Obligation Year</li>
                          <li>Federal Aid Committee (county level, except for the City of Detroit)</li>
                          <li>Jurisdiction (State, County, Local, …)</li>
                      </ul></li>
                      <li>Click the map pin icons (<span class="esri-icon-map-pin"></span>) next to the menus to show the projects by type or by year of construction.</li>
                      <li>Activate the attribute table at the bottom to see a more complete record of the project. </li>
                      <li>Transit, regionwide, and other projects with no particular location are placed on the administrative building of the project owner.</li>
                  </ul>
                  <p> If you would like to download a copy of the TIP data, please see
                      <a href="https://maps-semcog.opendata.arcgis.com/datasets/SEMCOG::tip-projects-fy-2023-to-2026" target="_blank">
                          SEMCOG’s Open Data Portal</a>.
                      For more information contact
                      <a href="mailto:infocenter@semcog.org?subject=TIP Question" target="_blank">SEMCOG</a>.
                      <a href="https://experience.arcgis.com/experience/f3a4872ac4444f5eac3adf4c656d0a53/page/TransportationProjPortal?views=Approved-STIP#data_s=id%3AdataSource_17-MdotStip_4346%3A10897358" target="_blank">
                        MDOT's Transportation Program Portal</a> if interested in another interactive map resource for TIP projects throughout the state.
                  </p>
              </div>
          </div>
      </transition>

      <!-- YouTube video iframe; move back to template when ready
      <div style="float: right; padding-left: 5px;">
                      <iframe style=" max-width: 100%;" width="560" height="315"
                              src="https://www.youtube.com/embed/l1PyQtVndW0"
                              frameborder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowfullscreen></iframe>
                  </div>-->

    </div>

</template>

<script>
    export default {
        name: "AboutPage",
        data: function () {
            return {
                aboutPage: true,
            }
        },
    }
</script>

<style scoped>
    .about {
        float: right;
        padding: 5px;
        color: black;
        background-color: white;
        font-weight: bold;
        border-radius: 5px;
        font-family: Arial, Helvetica, sans-serif;
    }
    .about:hover {
        background-color: #f3f3f3;
        cursor: pointer;
    }
    .aboutPage {
        position: fixed;
        background: rgba(46, 60, 67, 0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 2;
        opacity: 1;
        overflow: hidden;
    }
    .aboutPage-content {
        background: white;
        max-width: 80%;
        border: #fffcfc solid 2px;
        border-radius: 10px;
        padding: 10px 30px;
        max-height: 80%;
        overflow: auto;
        color: #212529;
        font-weight: normal;
        font-size: medium;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity 1s;
    }
    .fade-enter, .fade-leave-to
    {
        opacity: 0;
    }
    .fade-enter-active .aboutPage-content, .fade-leave-active .aboutPage-content {
        transition: transform 1s;
    }
    .fade-enter .aboutPage-content, .fade-leave-to .aboutPage-content {
        transform: translate(50vw, -50vh) scale(0);
    }
    .fade-enter-to .aboutPage-content, .fade-leave-to .aboutPage-content {
        overflow: hidden;
    }

    #infoButton {
        color: white;
        /*background: #ea711b;*/
        background: #B23346;
    }
    #infoText {
        font-family: Arial, Helvetica, sans-seri;
    }
    #infoButton:hover {
        /*background: #fb822c;*/
        background: #921326;
    }
    #infoButton:active {
        /*background: #ffa200;*/
        background: #E26376;
    }
</style>